import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  noContentStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "8rem",
  },
}));

const NoContentImportCSV = () => {
  const { noContentStyle } = useStyles();

  return <p className={noContentStyle}>Keine Daten</p>;
};

export default NoContentImportCSV;
